import React, { useState, useEffect, useRef } from "react";
import "./ResponsiveImageCarousel.css";

const ResponsiveImageCarousel = ({ images, timer = 3000, imageHeight = 300, gap = 0 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);

  // Add clones of first and last images for smooth looping
  const displayImages = [
    images[images.length - 1],  // Clone of the last image at the beginning
    ...images,
    images[0],                  // Clone of the first image at the end
    images[1],
  ];

  // Auto-slide interval
  useEffect(() => {
    const intervalId = setInterval(() => {
      slideToNext();
    }, timer);
    return () => clearInterval(intervalId);
  }, [timer]);

  // Adjusts position instantly when reaching cloned slides
  useEffect(() => {
    const handleTransitionEnd = () => {
      if (currentIndex === 0) {
        // Jump to the real last image
        carouselRef.current.style.transition = "none";
        setCurrentIndex(images.length);
      } else if (currentIndex === displayImages.length - 1) {
        // Jump to the real first image
        carouselRef.current.style.transition = "none";
        setCurrentIndex(1);
      }
    };

    const carouselElement = carouselRef.current;
    carouselElement.addEventListener("transitionend", handleTransitionEnd);

    return () => carouselElement.removeEventListener("transitionend", handleTransitionEnd);
  }, [currentIndex, images.length]);

  const slideToNext = () => {
    setCurrentIndex((prevIndex) => prevIndex + 1);
    carouselRef.current.style.transition = "transform 0.5s ease-in-out";
  };

  const slideToPrev = () => {
    setCurrentIndex((prevIndex) => prevIndex - 1);
    carouselRef.current.style.transition = "transform 0.5s ease-in-out";
  };

  // Apply transform to move slides based on current index
  useEffect(() => {
    if (carouselRef.current) {
      const itemWidth = carouselRef.current.firstChild.offsetWidth;
      carouselRef.current.style.transform = `translateX(-${currentIndex * (itemWidth + 10)}px)`;
    }
  }, [currentIndex]);

  return (
    <div className="responsive-image-carousel">
      <div className="responsive-carousel-inner" ref={carouselRef}>
        {displayImages.map((image, index) => (
          <div
            className="responsive-carousel-item"
            key={index}
            style={{ height: `${imageHeight}px`, marginRight: `${gap}px` }}
          >
            <img src={image.src} alt={image.alt} style={{ height: "100%", width: "auto" }} />
          </div>
        ))}
      </div>
      <button className="carousel-prev" onClick={slideToPrev}>
        &#10094;
      </button>
      <button className="carousel-next" onClick={slideToNext}>
        &#10095;
      </button>
    </div>
  );
};

export default ResponsiveImageCarousel;
